import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ErrorHandlerService {
  handle(error: unknown, context?: string): void {
    console.error(`[${context ?? 'ErrorHandlerService'}]`, error);
  }
}
